import React from "react";

const AdminFooter = () => {
	return (
		<footer className={"admin-footer"}>
			<span>Arteco Consulting SL, &copy; {new Date().getFullYear()}</span>
		</footer>
	);
};

export default AdminFooter;
